// core
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

// services
import { RaptorDataService } from '../../services/raptor-data.service';
import { RaptorControlService } from '../../services/raptor-control.service';
import { RaptorPredicateService } from '../../services/raptor-predicate.service';

@Component({
  selector: 'open-raptor-repeater-multiple-question',
  templateUrl: './raptor-repeater-multiple-question.component.html',
  styleUrls: ['./raptor-repeater-multiple-question.component.scss']
})
export class RaptorRepeaterMultipleQuestionComponent implements OnInit {
  @Input() question!: any;
  @Input() form!: FormGroup;
  @Input() submitted!: Boolean;

  columns: number = 1;
  setLength: number = 1;

  // We're using CSS position anchors for the positioning of the delete button for
  // browsers who support it. For those that don't, we have a JS fallback
  // that calculates the position needed for the delete buton.
  cssAnchorNameSupport: boolean = CSS.supports("anchor-name: --myAnchor");
  deleteResize!: any;
  @ViewChild('raptorRepeaterMultiple') raptorRepeaterMultiple!: ElementRef;

  constructor(
    public raptorDataService: RaptorDataService,
    private raptorControlService: RaptorControlService,
    private raptorPredicateService: RaptorPredicateService
  ) { }

  ngOnInit(): void {
    // this layout has already been done when setting up the multiple repeater question's fields
    this.columns = this.question.columns;
    this.setLength = this.question.fields.length;

    if (!this.cssAnchorNameSupport) {
      this.deleteResize = window.addEventListener('resize', this.setDeletePosition);
    }
  }

  ngOnDestroy(): void {
    if (this.deleteResize) {
      window.removeEventListener('resize', this.setDeletePosition);
    }
  }

  public add(): void  { 
    let newQuestions: Array<any> = [];
    let uniqueControls: Array<any> = [];
    this.setLength = this.setLength + 1;
    
    this.question.elements.forEach((column: any) => {
      let newColumn: Array<any> = [];
      column.forEach((element: any) => {
        // make a copy so that the current fields predicates are not altered, this needs to be a deep copy
        let field = JSON.parse(JSON.stringify(element));
        field.key = field.key + '_index' + this.setLength;
        field.dynamic = true;

        if (field.show_if && field.show_if.operands) {
          field.show_if.operands = this.raptorDataService.appendOperandKey(field.show_if.operands, this.setLength, this.question.key);
        }
        if (field.validations && field.validations.length) {
          field.validations.forEach((validation: any) => {
            if (validation.predicate && validation.predicate.operands) {
              validation.predicate.operands = this.raptorDataService.appendOperandKey(validation.predicate.operands, this.setLength, this.question.key);
            }
          });
        }
        if (field.type === 'medical_screening') {
          field.conditions = null;
        }
        newColumn.push(field);
      });

      
      newQuestions.push(newColumn);
    });

    newQuestions.forEach((column: any) => {
      column.forEach((question: any) => {
        if (!uniqueControls.find(({key}) => key === question.key)) {
          uniqueControls.push(question);
        }
      });
    });
    
    uniqueControls.forEach((question: any) => {
      this.raptorControlService.addFormControl(question);
    });

    this.question.fields.push(newQuestions);
    
    if (!this.cssAnchorNameSupport) {
      this.setDeletePosition();
    }
  }

  public remove(section: any, i: number) {
    this.question.fields = this.question.fields.filter((fieldGroup: AnalyserNode, index: number) => {
      return i !== index;
    });
    section.forEach((field: any) => {
      this.form.removeControl(field.key);
    });
  }

  public maxItems(): boolean {
    let isMax = false;

    if (this.question.settings && this.question.settings.max_items) {
      let itemCount = this.question.fields && this.question.fields.length ? this.question.fields.length : 0;
      isMax = itemCount >= parseInt(this.question.settings.max_items);
    }
    return isMax;
  }

  setDeletePosition = () => {
    requestAnimationFrame(() => {
      if (this.raptorRepeaterMultiple) {
        const questionFields = this.raptorRepeaterMultiple.nativeElement.querySelectorAll('.raptor-question-field');
        const buttonItems = this.raptorRepeaterMultiple.nativeElement.querySelectorAll('.raptor-repeater-multiple-remove');

        questionFields.forEach((questionField: any, index: number) => {
          const questionFieldOffset = questionField.offsetTop;
          if (buttonItems[index]) {
            buttonItems[index].style.transform = `translateY(${questionFieldOffset}px)`;
          }
        })
      }
    });
  } 

  showQuestion(question: any): boolean {
    let isShown = true;
    if (question.show_if && typeof question.show_if === 'object') {
      isShown = this.raptorPredicateService.validator(question.show_if, this.form.value);
    }
    return isShown;
  }
}
